import { render, staticRenderFns } from "./addItem.vue?vue&type=template&id=e2e7b7b4&scoped=true"
import script from "./addItem.vue?vue&type=script&lang=js"
export * from "./addItem.vue?vue&type=script&lang=js"
import style0 from "./addItem.vue?vue&type=style&index=0&id=e2e7b7b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e7b7b4",
  null
  
)

export default component.exports